// import React, { useState, useEffect } from "react";
// import WelcomeCard from "../../components/common/WelcomeCard";
// import { LiaBlogSolid } from "react-icons/lia";
// import { FaEdit, FaTrash, FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import axios from "axios";
// import Loader from "../../components/common/Loader";
// import AddSubserviceModal from "../../components/modals/AddSubserviceModal";
// import EditSubserviceModal from "../../components/modals/EditSubserviceModal";
// import toast from "react-hot-toast";

// const SubService = () => {
//   const [subServiceList, setSubServiceList] = useState([]);
//   const [filteredSubservices, setFilteredSubservices] = useState([]);
//   const [serviceList, setServiceList] = useState([]);
//   const [selectedService, setSelectedService] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const [openAddModal, setOpenAddModal] = useState(false);
//   const [openEditModal, setOpenEditModal] = useState(false);
//   const [selectedSubservice, setSelectedSubservice] = useState(null);

//   // Pagination state
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(8);

//   // Fetch all subservices
//   const fetchSubServices = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_URL}/subservices/get-all-subservices`
//       );
//       const subservices = Array.isArray(response.data.data)
//         ? response.data.data
//         : [];

//       setSubServiceList(subservices);
//       setFilteredSubservices(subservices);
//     } catch (err) {
//       console.error("Error fetching subservices:", err);
//       setError("Failed to load subservices");
//       toast.error("Failed to load subservices");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch all services
//   const fetchServices = async () => {
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_URL}/services/get-all-services`
//       );

//       const services = Array.isArray(response.data) ? response.data : [];
//       setServiceList(services);
//     } catch (err) {
//       console.error("Failed to fetch services:", err);
//       toast.error("Failed to load services");
//     }
//   };

//   useEffect(() => {
//     fetchSubServices();
//     fetchServices();
//   }, []);

//   // Filter subservices by selected service
//   const handleFilter = () => {
//     if (!selectedService) {
//       setFilteredSubservices(subServiceList);
//       toast("Showing all subservices");
//       return;
//     }

//     const filtered = subServiceList.filter(
//       (sub) => sub?.service?._id === selectedService
//     );

//     if (filtered.length === 0) {
//       toast.error("No subservices found for selected service");
//     }

//     setFilteredSubservices(filtered);
//     setCurrentPage(1); // reset pagination
//   };

//   const handleReset = () => {
//     setSelectedService("");
//     setFilteredSubservices(subServiceList);
//     toast.success("Filter cleared");
//   };

//   // Add new subservice to list
//   const handleSubserviceAdded = (newSubservice) => {
//     if (!newSubservice) return;
//     setSubServiceList((prev) => [newSubservice, ...prev]);
//     setFilteredSubservices((prev) => [newSubservice, ...prev]);
//   };

//   // Update subservice in list
//   const handleSubserviceUpdated = (updatedSubservice) => {
//     if (!updatedSubservice) return;
//     setSubServiceList((prev) =>
//       prev.map((s) => (s?._id === updatedSubservice?._id ? updatedSubservice : s))
//     );
//     setFilteredSubservices((prev) =>
//       prev.map((s) => (s?._id === updatedSubservice?._id ? updatedSubservice : s))
//     );
//     toast.success("Subservice updated successfully");
//   };

//   // Delete subservice
//   const handleDelete = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this subservice?")) return;
//     try {
//       await axios.delete(
//         `${process.env.REACT_APP_API_URL}/subservices/delete-subservice/${id}`
//       );
//       setSubServiceList((prev) => prev.filter((sub) => sub?._id !== id));
//       setFilteredSubservices((prev) => prev.filter((sub) => sub?._id !== id));
//       toast.success("Subservice deleted successfully");
//     } catch (err) {
//       console.error("Failed to delete subservice:", err);
//       toast.error("Failed to delete subservice");
//     }
//   };

//   const handleOpenAddModal = () => setOpenAddModal(true);
//   const handleCloseAddModal = () => setOpenAddModal(false);

//   const handleOpenEditModal = (subservice) => {
//     setSelectedSubservice(subservice);
//     setOpenEditModal(true);
//   };
//   const handleCloseEditModal = () => {
//     setSelectedSubservice(null);
//     setOpenEditModal(false);
//   };

//   // Pagination logic
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredSubservices.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredSubservices.length / itemsPerPage);

//   const paginate = (pageNumber) => setCurrentPage(pageNumber);
//   const nextPage = () => currentPage < totalPages && setCurrentPage(currentPage + 1);
//   const prevPage = () => currentPage > 1 && setCurrentPage(currentPage - 1);

//   if (error) {
//     return <div className="text-center text-red-500 mt-10">{error}</div>;
//   }

//   return (
//     <>
//       {/* Add Modal */}
//       <AddSubserviceModal
//         isOpen={openAddModal}
//         onClose={handleCloseAddModal}
//         onSubserviceAdded={handleSubserviceAdded}
//         allSubservices={fetchSubServices}
//         services={serviceList}
//       />

//       {/* Edit Modal */}
//       {selectedSubservice && (
//         <EditSubserviceModal
//           isOpen={openEditModal}
//           onClose={handleCloseEditModal}
//           subservice={selectedSubservice}
//           onSubserviceUpdated={handleSubserviceUpdated}
//           allSubservices={fetchSubServices}
//           services={serviceList}
//         />
//       )}

//       <div className="p-4">
//         <WelcomeCard />

//         {/* Filter Menu */}
//         <div className="flex flex-col sm:flex-row justify-between items-center mb-4 gap-3">
//           <h1 className="text-xl font-semibold text-[#000000] tracking-wider">
//             SubServices List
//           </h1>

//           <div className="flex items-center gap-2">
//             <select
//               value={selectedService}
//               onChange={(e) => setSelectedService(e.target.value)}
//               className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
//             >
//               <option value="">All Services</option>
//               {serviceList.map((srv) => (
//                 <option key={srv._id} value={srv._id}>
//                   {srv.serviceName}
//                 </option>
//               ))}
//             </select>

//             <button
//               onClick={handleFilter}
//               className="bg-orange-500 text-white px-4 py-2 rounded-md font-medium hover:bg-orange-600 transition"
//             >
//               Search
//             </button>

//             <button
//               onClick={handleReset}
//               className="bg-gray-300 text-gray-700 px-3 py-2 rounded-md font-medium hover:bg-gray-400 transition"
//             >
//               Reset
//             </button>

//             <button
//               onClick={handleOpenAddModal}
//               className="flex justify-center items-center bg-gradient-to-r from-[#FF3131] to-[#ff9301] text-white font-semibold tracking-wider py-2 px-4 rounded-md hover:bg-red-600 transition duration-300 ease-in-out"
//             >
//               <LiaBlogSolid size={24} className="mr-2" /> Add SubService
//             </button>
//           </div>
//         </div>

//         {loading ? (
//           <div className="rounded-md flex tracking-wider font-semibold justify-center items-center border border-slate-400 w-full p-4 mt-10">
//             <Loader /> <span className="ml-2">Loading Subservices...</span>
//           </div>
//         ) : filteredSubservices.length === 0 ? (
//           <div className="rounded-md flex tracking-wider font-semibold justify-center items-center border border-slate-400 w-full p-4">
//             No SubServices found.
//           </div>
//         ) : (
//           <>
//             <div className="container mx-auto">
//               <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
//                 {currentItems.map((sub) => (
//                   <div
//                     key={sub?._id}
//                     className="bg-white shadow-md rounded-lg p-4 transition transform hover:scale-105 relative"
//                   >
//                     <h2 className="text-xl font-bold text-center mb-2">
//                       {sub?.subserviceName}
//                     </h2>
//                     <h2 className="text-sm font-bold text-center mb-2 text-orange-500">
//                       {sub?.service?.serviceName}
//                     </h2>

//                     {sub?.images?.length > 0 && (
//                       <img
//                         src={sub.images[0]}
//                         alt={sub.subserviceName}
//                         className="w-full h-40 object-cover rounded mb-2"
//                       />
//                     )}

//                     {sub?.description?.length > 0 && (
//                       <div className="text-gray-600 text-sm text-center mb-3">
//                         {sub.description.map((d, i) => (
//                           <p key={i} className="mb-2 line-clamp-2">
//                             <span dangerouslySetInnerHTML={{ __html: d }} />
//                           </p>
//                         ))}
//                       </div>
//                     )}


//                     <div className="flex justify-center space-x-4 mt-2">
//                       <button
//                         onClick={() => handleOpenEditModal(sub)}
//                         className="text-blue-500 hover:text-blue-700"
//                         title="Edit Subservice"
//                       >
//                         <FaEdit size={20} />
//                       </button>
//                       <button
//                         onClick={() => handleDelete(sub?._id)}
//                         className="text-red-500 hover:text-red-700"
//                         title="Delete Subservice"
//                       >
//                         <FaTrash size={20} />
//                       </button>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             {/* Pagination */}
//             {totalPages > 1 && (
//               <div className="flex justify-center items-center mt-8 space-x-2">
//                 <button
//                   onClick={prevPage}
//                   disabled={currentPage === 1}
//                   className={`p-2 rounded-md ${currentPage === 1
//                       ? "bg-gray-200 text-gray-400 cursor-not-allowed"
//                       : "bg-orange-500 text-white hover:bg-orange-600"
//                     }`}
//                 >
//                   <FaChevronLeft />
//                 </button>

//                 {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
//                   <button
//                     key={page}
//                     onClick={() => paginate(page)}
//                     className={`px-3 py-1 rounded-md ${currentPage === page
//                         ? "bg-orange-500 text-white"
//                         : "bg-gray-200 text-gray-700 hover:bg-gray-300"
//                       }`}
//                   >
//                     {page}
//                   </button>
//                 ))}

//                 <button
//                   onClick={nextPage}
//                   disabled={currentPage === totalPages}
//                   className={`p-2 rounded-md ${currentPage === totalPages
//                       ? "bg-gray-200 text-gray-400 cursor-not-allowed"
//                       : "bg-orange-500 text-white hover:bg-orange-600"
//                     }`}
//                 >
//                   <FaChevronRight />
//                 </button>
//               </div>
//             )}

//             <div className="text-center mt-4 text-gray-600">
//               Showing {indexOfFirstItem + 1} to{" "}
//               {Math.min(indexOfLastItem, filteredSubservices.length)} of{" "}
//               {filteredSubservices.length} subservices
//             </div>
//           </>
//         )}
//       </div>
//     </>
//   );
// };

// export default SubService;


import React, { useState, useEffect } from "react";
import WelcomeCard from "../../components/common/WelcomeCard";
import { LiaBlogSolid } from "react-icons/lia";
import { FaEdit, FaTrash, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import axios from "axios";
import Loader from "../../components/common/Loader";
import AddSubserviceModal from "../../components/modals/AddSubserviceModal";
import EditSubserviceModal from "../../components/modals/EditSubserviceModal";
import toast from "react-hot-toast";

const SubService = () => {
  const [subServiceList, setSubServiceList] = useState([]);
  const [filteredSubservices, setFilteredSubservices] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [selectedService, setSelectedService] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [openAddModal, setOpenAddModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedSubservice, setSelectedSubservice] = useState(null);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(8);

  // Fetch all subservices
  const fetchSubServices = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/subservices/get-all-subservices`
      );
      const subservices = Array.isArray(response.data.data)
        ? response.data.data
        : [];

      setSubServiceList(subservices);
      setFilteredSubservices(
        selectedService
          ? subservices.filter((sub) => sub?.service?._id === selectedService)
          : subservices
      );
    } catch (err) {
      console.error("Error fetching subservices:", err);
      setError("Failed to load subservices");
      toast.error("Failed to load subservices");
    } finally {
      setLoading(false);
    }
  };

  // Fetch all services
  const fetchServices = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/services/get-all-services`
      );
      const services = Array.isArray(response.data) ? response.data : [];
      setServiceList(services);
    } catch (err) {
      console.error("Failed to fetch services:", err);
      toast.error("Failed to load services");
    }
  };

  useEffect(() => {
    fetchServices();
    fetchSubServices();
  }, []);

  // Update filtered subservices automatically when service changes
  useEffect(() => {
    if (!selectedService) {
      setFilteredSubservices(subServiceList);
    } else {
      setFilteredSubservices(
        subServiceList.filter((sub) => sub?.service?._id === selectedService)
      );
      setCurrentPage(1); 
    }
  }, [selectedService, subServiceList]);

  // Add new subservice to list
  const handleSubserviceAdded = (newSubservice) => {
    if (!newSubservice) return;
    setSubServiceList((prev) => [newSubservice, ...prev]);
    if (!selectedService || newSubservice?.service?._id === selectedService) {
      setFilteredSubservices((prev) => [newSubservice, ...prev]);
    }
  };

  // Update subservice in list
  const handleSubserviceUpdated = (updatedSubservice) => {
    if (!updatedSubservice) return;
    setSubServiceList((prev) =>
      prev.map((s) => (s?._id === updatedSubservice?._id ? updatedSubservice : s))
    );
    setFilteredSubservices((prev) =>
      prev.map((s) => (s?._id === updatedSubservice?._id ? updatedSubservice : s))
    );
    toast.success("Subservice updated successfully");
  };

  // Delete subservice
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this subservice?")) return;
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_URL}/subservices/delete-subservice/${id}`
      );
      setSubServiceList((prev) => prev.filter((sub) => sub?._id !== id));
      setFilteredSubservices((prev) => prev.filter((sub) => sub?._id !== id));
      toast.success("Subservice deleted successfully");
    } catch (err) {
      console.error("Failed to delete subservice:", err);
      toast.error("Failed to delete subservice");
    }
  };

    const handleReset = () => {
    setSelectedService("");
    setFilteredSubservices(subServiceList);
    toast.success("Filter cleared");
  };

  const handleOpenAddModal = () => setOpenAddModal(true);
  const handleCloseAddModal = () => setOpenAddModal(false);

  const handleOpenEditModal = (subservice) => {
    setSelectedSubservice(subservice);
    setOpenEditModal(true);
  };
  const handleCloseEditModal = () => {
    setSelectedSubservice(null);
    setOpenEditModal(false);
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredSubservices.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredSubservices.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const nextPage = () => currentPage < totalPages && setCurrentPage(currentPage + 1);
  const prevPage = () => currentPage > 1 && setCurrentPage(currentPage - 1);

  if (error) {
    return <div className="text-center text-red-500 mt-10">{error}</div>;
  }

  return (
    <>
      {/* Add Modal */}
      <AddSubserviceModal
        isOpen={openAddModal}
        onClose={handleCloseAddModal}
        onSubserviceAdded={handleSubserviceAdded}
        allSubservices={fetchSubServices}
        services={serviceList}
      />

      {/* Edit Modal */}
      {selectedSubservice && (
        <EditSubserviceModal
          isOpen={openEditModal}
          onClose={handleCloseEditModal}
          subservice={selectedSubservice}
          onSubserviceUpdated={handleSubserviceUpdated}
          allSubservices={fetchSubServices}
          services={serviceList}
        />
      )}

      <div className="p-4">
        <WelcomeCard />

        {/* Filter Dropdown */}
        <div className="flex flex-col sm:flex-row justify-between items-center mb-4 gap-3">
          <h1 className="text-xl font-semibold text-[#000000] tracking-wider">
            SubServices List
          </h1>

          <div className="flex items-center gap-2">
            <select
              value={selectedService}
              onChange={(e) => setSelectedService(e.target.value)}
              className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
            >
              <option value="">All Services</option>
              {serviceList.map((srv) => (
                <option key={srv._id} value={srv._id}>
                  {srv.serviceName}
                </option>
              ))}
            </select>
             <button
              onClick={handleReset}
              className="bg-gray-300 text-gray-700 px-3 py-2 rounded-md font-medium hover:bg-gray-400 transition"
            >
              Reset
            </button>

            <button
              onClick={handleOpenAddModal}
              className="flex justify-center items-center bg-gradient-to-r from-[#FF3131] to-[#ff9301] text-white font-semibold tracking-wider py-2 px-4 rounded-md hover:bg-red-600 transition duration-300 ease-in-out"
            >
              <LiaBlogSolid size={24} className="mr-2" /> Add SubService
            </button>
          </div>
        </div>

        {loading ? (
          <div className="rounded-md flex tracking-wider font-semibold justify-center items-center border border-slate-400 w-full p-4 mt-10">
            <Loader /> <span className="ml-2">Loading Subservices...</span>
          </div>
        ) : filteredSubservices.length === 0 ? (
          <div className="rounded-md flex tracking-wider font-semibold justify-center items-center border border-slate-400 w-full p-4">
            No SubServices found.
          </div>
        ) : (
          <>
            <div className="container mx-auto">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                {currentItems.map((sub) => (
                  <div
                    key={sub?._id}
                    className="bg-white shadow-md rounded-lg p-4 transition transform hover:scale-105 relative"
                  >
                    <h2 className="text-xl font-bold text-center mb-2">
                      {sub?.subserviceName}
                    </h2>
                    <h2 className="text-sm font-bold text-center mb-2 text-orange-500">
                      {sub?.service?.serviceName}
                    </h2>

                    {sub?.images?.length > 0 && (
                      <img
                        src={sub.images[0]}
                        alt={sub.subserviceName}
                        className="w-full h-40 object-cover rounded mb-2"
                      />
                    )}

                    {sub?.description?.length > 0 && (
                      <div className="text-gray-600 text-sm text-center mb-3">
                        {sub.description.map((d, i) => (
                          <p key={i} className="mb-2 line-clamp-2">
                            <span dangerouslySetInnerHTML={{ __html: d }} />
                          </p>
                        ))}
                      </div>
                    )}

                    <div className="flex justify-center space-x-4 mt-2">
                      <button
                        onClick={() => handleOpenEditModal(sub)}
                        className="text-blue-500 hover:text-blue-700"
                        title="Edit Subservice"
                      >
                        <FaEdit size={20} />
                      </button>
                      <button
                        onClick={() => handleDelete(sub?._id)}
                        className="text-red-500 hover:text-red-700"
                        title="Delete Subservice"
                      >
                        <FaTrash size={20} />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="flex justify-center items-center mt-8 space-x-2">
                <button
                  onClick={prevPage}
                  disabled={currentPage === 1}
                  className={`p-2 rounded-md ${currentPage === 1
                      ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                      : "bg-orange-500 text-white hover:bg-orange-600"
                    }`}
                >
                  <FaChevronLeft />
                </button>

                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <button
                    key={page}
                    onClick={() => paginate(page)}
                    className={`px-3 py-1 rounded-md ${currentPage === page
                        ? "bg-orange-500 text-white"
                        : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                      }`}
                  >
                    {page}
                  </button>
                ))}

                <button
                  onClick={nextPage}
                  disabled={currentPage === totalPages}
                  className={`p-2 rounded-md ${currentPage === totalPages
                      ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                      : "bg-orange-500 text-white hover:bg-orange-600"
                    }`}
                >
                  <FaChevronRight />
                </button>
              </div>
            )}

            <div className="text-center mt-4 text-gray-600">
              Showing {indexOfFirstItem + 1} to{" "}
              {Math.min(indexOfLastItem, filteredSubservices.length)} of{" "}
              {filteredSubservices.length} subservices
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default SubService;

